// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const GetLease = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        lease: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        getLeaseHandler: async function(property_id, lease_id) {

            try {

                propertiesModel.doc(property_id).collection('leases').doc(lease_id).get()
                .then(doc => {

                    /*
                    **  If doc doesn't exist or has been deleted
                    */

                    if (!doc.exists || doc.exists && doc.data().meta.deleted_at) return;

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.lease = doc.data();

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Get the Lease from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Leases',
                        uid: 'mAco9a746wrWW6oWW3f7',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Perform the Query to Get the Lease Document from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Leases',
                    uid: 'H4z15FCDkBjtldchQrAr',
                    error: e
                });

            }

        }

    }

}